<div class="hover-effect-menu {{icons}}-icons">
    <div class="short-arrow">
        <span class="material-icons">more_horiz</span>
        <span class="badge-notify" *ngIf="element.unreadCount > 0">{{element.unreadCount}}</span>
        <span *ngIf="element.isReadCandidate || element.isReadJob" class="red-dot"></span>
    </div>
    <div class="hover-round-effect">
        <button mat-menu-item *ngIf="!element.unreadCount && dissOn" [routerLink]="route" [queryParams]="{ id: element.id}" matTooltip="{{'See Applications' | translate}}">
            <span class="material-icons">description</span>
            <!--<img src="assets/images/view-report.svg" alt="" style="margin: 0px">-->
        </button>
        <button mat-menu-item *ngIf="element.unreadCount > 0 && dissOn" [routerLink]="route" [queryParams]="{ id: element.id}" matTooltip="{{'See Applications' | translate}}">
            <span class="badge-notify-wrap">
                <!--<img src="assets/images/view-report.svg" alt="" style="margin: 0px">-->
                <span class="material-icons">description</span>
                <span class="badge-notify">{{element.unreadCount}}</span>
            </span>
        </button>
        <button *ngIf="viewOn" mat-menu-item (click)="viewDetail()" matTooltip="{{'TABLE.ViewDetails' | translate}}">
            <span class="material-icons">remove_red_eye <span *ngIf="element.isReadCandidate || element.isReadJob" class="red-dot"></span></span>
        </button>
        <button (click)="changeLogMethod()" *ngIf="changeLogOn" mat-menu-item matTooltip="{{'log button' | translate}}">
            <span class="material-icons">checklist_rtl</span>
        </button>
        <button *ngIf="logOn" mat-menu-item (click)="changeDetails()" matTooltip="{{'TABLE.ChangeLog' | translate}}">
            <span class="material-icons">checklist_rtl</span>
        </button>
        <button *ngIf="editOn" mat-menu-item (click)="editEvent()" matTooltip="{{'Edit' | translate}}">
            <span class="material-icons">edit</span>
        </button>
        <button *ngIf="blockOn" (click)="blockEvent()" mat-menu-item matTooltip="{{'Suspend' | translate}}">
            <span class="material-icons">block</span>
        </button>
        <button *ngIf="restoreOn" (click)="restoreEvent()" mat-menu-item matTooltip="{{'Restore' | translate}}">
            <span class="material-icons">settings_backup_restore</span>
        </button>
        <button *ngIf="cancelOn" mat-menu-item (click)="cancelEvent()" matTooltip="{{'Cancel' | translate}}">
            <span class="material-icons">event_busy</span>
        </button>
        <button *ngIf="activeOn" mat-menu-item (click)="activeEvent()" matTooltip="{{'Active_Event' | translate}}">
            <span class="material-icons">event_available</span>
        </button>
        <button (click)="acceptInvitation()" *ngIf="acceptOn" mat-menu-item matTooltip="{{'Accept_Invitation' | translate}}">
            <span class="material-icons">done</span>
        </button>
        <button (click)="declineInvitation()" *ngIf="declineOn" mat-menu-item matTooltip="{{'Decline_Invitation' | translate}}">
            <span class="material-icons">clear</span>
        </button>
        <button (click)="viewDetail()" *ngIf="viewCertificateOn" mat-menu-item matTooltip="{{'ViewAttendanceCertificate' | translate}}">
            <span class="material-icons">remove_red_eye <span *ngIf="element.isReadCandidate || element.isReadJob" class="red-dot"></span></span>
        </button>

        <button *ngIf="commentOn" mat-menu-item (click)="commentAction()" matTooltip="{{'TABLE.ShowUserActivity' | translate}}">
            <span class="material-icons">comment</span>
        </button>
        <button *ngIf="lockOn" mat-menu-item (click)="openUnlock()" matTooltip="{{'Unlock Pairing' | translate}}">
            <span class="material-icons">lock</span>
        </button>
        <button *ngIf="qrOn" mat-menu-item (click)="openQR()" matTooltip="{{'INSIGHTS_PEOPLE_PAGE.TOUCHPOINT QR' | translate}}">
            <span class="material-icons">qr_code_2</span>
        </button>
      <button *ngIf="editCreditOn" mat-menu-item (click)="editEventCredit()" matTooltip="{{'EVENT_MANAGEMENT.Edit Event Credit' | translate}}">
        <span class="material-icons">edit_note</span>
      </button>
        <button *ngIf="planOn" mat-menu-item (click)="planAction()" matTooltip="{{'TABLE.ModifyUserActivity' | translate}}">
            <span class="material-icons">event</span>
        </button>

        <button *ngIf="changeRoleOn" mat-menu-item (click)="changeSelectedAttendeeRole()" matTooltip="{{'ChangeRole' | translate}}">
            <span class="material-icons"> group </span>
           <!-- <img src="assets/images/attendees-icon.svg" alt="" style="margin: 0px">-->
        </button>

        <button (click)="reBookMethod()" *ngIf="reBook" mat-menu-item matTooltip="{{'Move' | translate}}">
            <span class="material-icons">low_priority</span>
        </button>

        <button *ngIf="deleteOn" mat-menu-item (click)="deleteEvent()" matTooltip="{{'Delete' | translate}}">
            <span class="material-icons">delete</span>
        </button>
        <button (click)="reservationResource()" *ngIf="reservationOn" mat-menu-item matTooltip="Book">
            <span class="material-icons"> event_available </span>
        </button>

        <button (click)="removeReservationResource()" *ngIf="removeReservationOn" mat-menu-item matTooltip="Remove Book">
            <span class="material-icons"> event_busy </span>
        </button>

        <button (click)="awardBadgeMethod()" *ngIf="awardBadgeOn" mat-menu-item matTooltip="Assign Badge">
            <span class="material-icons"> credit_card </span>
        </button>

        <button (click)="returnBadgeMethod()" *ngIf="returnBadgeOn" mat-menu-item matTooltip="Return Badge">
            <span class="material-icons"> badge </span>
        </button>

        <button (click)="assignSiteMethod()" *ngIf="assignSiteOn" mat-menu-item matTooltip="Assign Site">
            <span class="material-icons">add_location</span>
        </button>

        <button (click)="sendInvitationMethod()" *ngIf="sendInvitationOn" mat-menu-item matTooltip="Send Invite">
            <span class="material-icons"> send </span>
        </button>
        <button (click)="opensiteZone()" *ngIf="zone" mat-menu-item matTooltip="{{'TABLE.ZONE'| translate}}">
            <span class="material-icons"> my_location </span>
        </button>

        <button (click)="openListVenuesOn()" *ngIf="listVenuesOn" mat-menu-item matTooltip="{{'PEOPLE_CARING.ListOfVenues'| translate}}">
            <span class="material-icons"> my_location </span>
        </button>

        <button (click)="divisionEvent()" *ngIf="divisionOn" mat-menu-item matTooltip="{{'TABLE.division'| translate}}">
            <span class="material-icons">category</span>
        </button>
        <button (click)="unitEvent()" *ngIf="unitOn" mat-menu-item matTooltip="{{'TABLE.unit' | translate}}">
            <span class="material-icons">donut_large</span>
        </button>

        <button (click)="restrictedModeMethod()" *ngIf="restrictedModeOn" mat-menu-item matTooltip="Restricted Mode">
            <span class="material-icons">
                <svg height="24" version="1.1" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M12,5.5A3.5,3.5 0 0,1 15.5,9A3.5,3.5 0 0,1 12,12.5A3.5,3.5 0 0,1 8.5,9A3.5,3.5 0 0,1 12,5.5M5,8C5.56,8 6.08,8.15 6.53,8.42C6.38,9.85 6.8,11.27 7.66,12.38C7.16,13.34 6.16,14 5,14A3,3 0 0,1 2,11A3,3 0 0,1 5,8M19,8A3,3 0 0,1 22,11A3,3 0 0,1 19,14C17.84,14 16.84,13.34 16.34,12.38C17.2,11.27 17.62,9.85 17.47,8.42C17.92,8.15 18.44,8 19,8M5.5,18.25C5.5,16.18 8.41,14.5 12,14.5C15.59,14.5 18.5,16.18 18.5,18.25V20H5.5V18.25M0,20V18.5C0,17.11 1.89,15.94 4.45,15.6C3.86,16.28 3.5,17.22 3.5,18.25V20H0M24,20H20.5V18.25C20.5,17.22 20.14,16.28 19.55,15.6C22.11,15.94 24,17.11 24,18.5V20Z" fill="#ffffff"/></svg>
            </span>
        </button>

        <button (click)="departmentsQuotasMethod()" *ngIf="departmentsQuotasOn" mat-menu-item matTooltip="Edit departments quotas">
            <span class="material-icons"> insert_comment </span>
        </button>

        <button (click)="duplicateMethod()" *ngIf="duplicateOn" mat-menu-item matTooltip="Duplicate">
            <span class="material-icons"> content_copy </span>
        </button>

        <button (click)="executeMethod()" *ngIf="executeOn" mat-menu-item matTooltip="Run now">
            <span class="material-icons"> play_circle_filled  </span>
        </button>

        <button (click)="editResourceReservationMethod()" *ngIf="editResourceReservationOn" mat-menu-item matTooltip="{{'PEOPLE_CARING.EditResourceReservations' | translate}}">
            <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7,12H9V14H7V12M21,6V20A2,2 0 0,1 19,22H5C3.89,22 3,21.1 3,20V6A2,2 0 0,1 5,4H6V2H8V4H16V2H18V4H19A2,2 0 0,1 21,6M5,8H19V6H5V8M19,20V10H5V20H19M15,14V12H17V14H15M11,14V12H13V14H11M7,16H9V18H7V16M15,18V16H17V18H15M11,18V16H13V18H11Z" fill="#ffffff"/></svg>
        </button>

        <button (click)="sendAvailabilityMailMethod()" *ngIf="sendAvailabilityMailOn" mat-menu-item matTooltip="{{'Send Availability Mail' | translate}}">
            <svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M12 .64L8.23 3H5V5L2.97 6.29C2.39 6.64 2 7.27 2 8V18C2 19.11 2.9 20 4 20H20C21.11 20 22 19.11 22 18V8C22 7.27 21.61 6.64 21.03 6.29L19 5V3H15.77M7 5H17V9.88L12 13L7 9.88M8 6V7.5H16V6M5 7.38V8.63L4 8M19 7.38L20 8L19 8.63M8 8.5V10H16V8.5Z" fill="#ffffff"/></svg>
        </button>

        <button (click)="deleteReservationPeopleCaring()" *ngIf="deleteReservationOn" mat-menu-item matTooltip="{{'PEOPLE_CARING.InspectReservations' | translate}}">
            <span class="material-icons"> search  </span>
        </button>

        <button (click)="addUserEvent()" *ngIf="addUserOn" mat-menu-item  matTooltip="{{'PEOPLE_CARING.AddUser' | translate}}">
            <span class="material-icons"> person_add  </span>
        </button>
        <button (click)="reservationExec()" *ngIf="resCalenderOn" mat-menu-item matTooltip="Reservation Calender">
            <span class="material-icons"> person_add  </span>
        </button>
        <button (click)="showLog()" *ngIf="eventLogOn" mat-menu-item matTooltip="Scheduler Log">
            <span class="material-icons">checklist_rtl</span>
        </button>
        <button *ngIf="unLockOn" mat-menu-item (click)="unlockMethod()" matTooltip="{{'ACCESS_CONTROL.Unlock' | translate}}">
            <span class="material-icons">lock_open</span>
        </button>
        <button *ngIf="resetOn" (click)="resetEvent()" mat-menu-item matTooltip="{{'SITES.Reset' | translate}}">
            <span class="material-icons">settings_backup_restore</span>
        </button>
    </div>
</div>



<!--<span class="mat-button-wrapper"><i _ngcontent-eab-c277="" class="material-icons">person_add</i></span>-->
